const metricItems = [
  { value: "67 mil+", label: "flashcards publicadas" },
  { value: "35 mil+", label: "preguntas publicadas" },
  { value: "900+", label: "temas organizados" },
  { value: "8", label: "familias de fuentes" },
];

export function MetricsSection() {
  return (
    <section aria-label="Contenido publicado" className="border-b border-border bg-muted/30 py-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 gap-7 lg:grid-cols-4">
          {metricItems.map((item) => (
            <div key={item.label} className="text-center">
              <p className="text-3xl font-black text-primary sm:text-4xl">{item.value}</p>
              <p className="mt-1 text-sm text-muted-foreground">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
